export interface ChannelGroup {
  name: string;
  channels: string[];
}

export const channelGroups: ChannelGroup[] = [
  {
    name: 'Amazon USA',
    channels: ['Amazon'],
  },
  {
    name: 'Amazon Canada',
    channels: ['Amazon.ca'],
  },
  {
    name: 'Amazon EU',
    channels: ['Amazon.de', 'Amazon.es', 'Amazon.nl', 'Amazon.fr', 'Amazon.ie', 'Amazon.it', 'Amazon.com.be', 'Amazon.pl', 'Amazon.se'],
  },
  {
    name: 'Amazon UK',
    channels: ['Amazon.co.uk'],
  },
  {
    name: 'Amazon Australia',
    channels: ['Amazon.com.au'],
  },
  {
    name: 'Shopify',
    channels: ['Shopify', 'Shopify Subscriptions', 'Target', 'TikTok', 'Shopify EU', 'Shopify UK', 'Shopify CA', 'Shopify AU', 'Shopify US'],
  },
];

export const getGroupForChannel = (channel: string): string | null => {
  for (const group of channelGroups) {
    if (group.channels.includes(channel)) {
      return group.name;
    }
  }
  return null;
};

export const getChannelsInGroup = (groupName: string): string[] => {
  const group = channelGroups.find((g) => g.name === groupName);
  return group?.channels ?? [];
};

export const isGroupName = (name: string): boolean => {
  return channelGroups.some((g) => g.name === name);
};

export const isExpandableGroup = (groupName: string): boolean => {
  const group = channelGroups.find((g) => g.name === groupName);
  return group ? group.channels.length > 1 : false;
};
